import React, { useEffect, useState } from 'react';
import { Card, Button, Form, Row, Col, Modal } from 'react-bootstrap';
import { useMutation, useQueryClient } from 'react-query';
import { Formik } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { HOCPHANTIENSI_API } from '../../../../utils/apiUrl';
import { Put } from '../../../../utils/httpProvider';
import moment from 'moment';
import { trangThaiHocPhanValue, objectLoaiHocPhan } from '../../../../utils/define';
import DocumentInput from '../../../../components/document-input/DocumentInput';
import { BaseGatewayImage } from '../../../../utils/apiUrl';

const schema = yup.object().shape({
    loaiHocPhan: yup.string().required('Vui lòng chọn học phần'),
    tenHocPhan: yup.string().required('Vui lòng nhập tên học phần')
});


const HocPhanTienSiEdit = ({ hoSoId, dataEdit, setViewMode, refreshList, isView = false, isUserView = false }) => {
    const queryClient = useQueryClient();
    const [initialValues, setInitialValues] = useState(null);

    useEffect(() => {
        if (dataEdit) {
            setInitialValues({
                loaiHocPhan: dataEdit.loaiHocPhan || '',
                tenHocPhan: dataEdit.tenHocPhan || '',
                tuNgay: dataEdit.tuNgay ? moment(dataEdit.tuNgay).format('YYYY-MM-DD') : '',
                denNgay: dataEdit.denNgay ? moment(dataEdit.denNgay).format('YYYY-MM-DD') : '',
                fileBanHanh: dataEdit.fileBanHanh || ''
            });
        }
    }, [dataEdit]);

    const editFunc = useMutation((value) => Put(`${HOCPHANTIENSI_API.UPDATE_ITEM}/${dataEdit.id}`, null, value, false));

    const handleUpdate = (values, { setSubmitting }) => {
        const requestData = {
            HoSoNghienCuuSinhId: hoSoId,
            LoaiHocPhan: values.loaiHocPhan,
            TenHocPhan: values.tenHocPhan,
            TuNgay: values.tuNgay || null,
            DenNgay: values.denNgay || null,
            TrangThai: dataEdit.trangThai || trangThaiHocPhanValue.choHoc,
            FileBanHanh: values.fileBanHanh
        };

        editFunc.mutate(requestData, {
            onSuccess: (res) => {
                setSubmitting(false);
                if (res && (res.status === 200 || res.status === 201 || res.status === 204)) {
                    toast.success('Cập nhật thành công');
                    queryClient.invalidateQueries(['hocPhanTienSiData', hoSoId]);
                    queryClient.invalidateQueries(['duyetHocPhanTienSiData', hoSoId]);
                    if (refreshList) {
                        refreshList();
                    }
                    setViewMode('list');
                } else {
                    toast.error(res?.message || 'Có lỗi xảy ra');
                }
            },
            onError: (err) => {
                setSubmitting(false);
                toast.error(err?.message || 'Có lỗi xảy ra trong quá trình xử lý');
            }
        });
    };

    if (!initialValues) return null;

    return (
        <Modal show={true} onHide={() => setViewMode('list')} size="lg" backdrop="static">
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>{isView ? 'Chi tiết Học phần tiến sĩ' : 'Cập nhật Học phần tiến sĩ'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={handleUpdate}
                    initialValues={initialValues}
                    enableReinitialize
                >
                    {({ handleSubmit, handleChange, handleBlur, values, errors, touched, isSubmitting, setFieldValue }) => (
                        <Form noValidate onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Loại học phần <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="loaiHocPhan"
                                            value={values.loaiHocPhan}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            disabled={isView || isUserView}
                                            className={isView || isUserView ? "bg-white" : ""}
                                        >
                                            <option value="">Chọn học phần</option>
                                            {objectLoaiHocPhan.map((item, index) => (
                                                <option key={index} value={item.value}>{item.label}</option>
                                            ))}
                                        </Form.Control>
                                        {touched.loaiHocPhan && !!errors.loaiHocPhan && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.loaiHocPhan}</div>}
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Tên học phần <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="tenHocPhan"
                                            value={values.tenHocPhan}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            disabled={isView || isUserView}
                                            className={isView || isUserView ? "bg-white" : ""}
                                        />
                                        {touched.tenHocPhan && !!errors.tenHocPhan && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.tenHocPhan}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Từ ngày</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="tuNgay"
                                            value={values.tuNgay}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            disabled={isView || isUserView}
                                            className={isView || isUserView ? "bg-white" : ""}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Đến ngày</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="denNgay"
                                            value={values.denNgay}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            disabled={isView || isUserView}
                                            className={isView || isUserView ? "bg-white" : ""}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Group style={{ pointerEvents: isView || isUserView ? 'none' : 'auto' }}>
                                        <DocumentInput
                                            labelTitle="File ký ban hành quyết định"
                                            value={values.fileBanHanh}
                                            onChangeProp={(url) => setFieldValue('fileBanHanh', url)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            {!isView && !isUserView ? (
                                <div className="text-right mt-3">
                                    <Button variant="secondary" className="mr-2" onClick={() => setViewMode('list')} disabled={isSubmitting}>
                                        Hủy
                                    </Button>
                                    <Button variant="primary" type="submit" disabled={isSubmitting}>
                                        {isSubmitting ? 'Đang lưu...' : 'Cập nhật'}
                                    </Button>
                                </div>
                            ) : (
                                <div className="text-right mt-3">
                                    <Button variant="secondary" onClick={() => setViewMode('list')}>
                                        Đóng
                                    </Button>
                                </div>
                            )}
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
};

export default HocPhanTienSiEdit;
